



























import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'
import S3Handler from '@/mixins/ai-s3'
import { mixins } from 'vue-class-component'
import { showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import UploadProgress from './UploadProgress.vue'
@Component({
  components: {
    UploadProgress
  }
})
export default class UploadFile extends mixins(S3Handler) {
  acceptFileTypes = ['pdf', 'tiff', 'jpg', 'jpeg', 'png']
  active = false
  targetFile: any = {
    size: 0,
    name: ''
  }
  indeterminate = false
  progressShow = false

  @Emit('success')
  onSuccess () {

  }

  @Emit('preview')
  onPreview (blobUrl: string) {
    const { filesInfoAI, targetFile, storeKeyAI } = this
    const file = filesInfoAI[0]
    return {
      blobUrl,
      file,
      storeKey: storeKeyAI,
      targetFile
    }
  }

  @Watch('filesInfo', { deep: true })
  onFilesInfoChanged (val: []) {
    if (!val.length) {
      return
    }
    this.onSuccess()
    showNotification({
      msg: '上传成功',
      type: SnackType.Success
    })
  }

  @Watch('blobUrl')
  onBlobUrlChanged (val: string) {
    if (!val) {
      return
    }
    this.onPreview(val)
  }

  chooseUploadFile (e: any) {
    const file = e.target.files.item(0)
    if (!file) return
    this.targetFile = file
    this.beforeUploadFile()
    e.target.value = ''
  }

  forbidDefaultEvent (e: any) {
    e.preventDefault()
  }

  fileDrop (e: any) {
    e.preventDefault()
    const file = e.dataTransfer.files[0] // 获取到第一个上传的文件对象
    if (!file) return
    this.targetFile = file
    this.beforeUploadFile()
  }

  beforeUploadFile () {
    const type = this.targetFile.name.split('.')[1].toLowerCase()
    if (!this.acceptFileTypes.includes(type)) {
      showNotification({
        msg: '暂不支持上传此格式文件',
        type: SnackType.Error
      })
      return
    }
    const ifImage = ['png', 'jpeg', 'tiff', 'jpg'].includes(type)
    if (ifImage && this.targetFile.size > 10 * 1000 * 1000) {
      showNotification({
        msg: '图片大小不能超过10M',
        type: SnackType.Error
      })
      return
    }
    this.fileTypeAI = ifImage ? 'img' : 'pdf'
    this.filesToUploadAI[0] = this.targetFile
    this.upLoadFileRequest()
  }

  async upLoadFileRequest () {
    this.progressShow = true
    this.indeterminate = true
    if (!this.checkCredentialValidAI()) {
      await this.getSTSCredentialsAI()
    }
    this.indeterminate = false
    await this.uploadFileToS3AI(0)
  }

  handleDeleteFile () {
    this.isToDelete = true
    this.progressShow = false
    this.targetFile = {
      name: '',
      size: 0
    }
  }
}
